"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdminAuthentication = exports.useIdTokenResult = exports.useAuthentication = exports.changeUserPassword = exports.isSignInWithEmailLink = exports.signOut = exports.useSignIn = exports.useMailAuth = exports.useResetPasswordAdmin = exports.useSignUp = void 0;
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const auth_1 = require("firebase/auth");
const swr_1 = __importDefault(require("swr"));
const react_1 = require("react");
const react_smart_hook_firebase_1 = require("@smart-hook/react-smart-hook-firebase");
require("./authSync");
const firebaseAuth = __importStar(require("firebase/auth"));
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.auth = auth;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.firebaseAuth = firebaseAuth;
class AppError extends Error {
    constructor(message, name) {
        super(message);
        if (name) {
            this.name = name;
        }
    }
}
// const createSWRHook =
//   <P, R>(fetcher: (arg: P) => Promise<R>) =>
//   (arg: P) =>
//     useSWR(arg, fetcher);
const createAsyncHook = (fetcher) => {
    return () => {
        const [params, setParams] = (0, react_1.useState)({});
        const { data, error, running } = params;
        return [
            (params) => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    setParams({ running: true });
                    const data = yield fetcher(params);
                    setParams({ data });
                }
                catch (e) {
                    setParams({ error: e });
                }
            }),
            data,
            running,
            error,
        ];
    };
};
const signUp = (_a) => __awaiter(void 0, [_a], void 0, function* ({ email, path, scriptId, campaignId, locale, contractId, }) {
    // noop
    return true;
});
exports.useSignUp = createAsyncHook(signUp);
const resetPasswordAdmin = (_b) => __awaiter(void 0, [_b], void 0, function* ({ email, path, }) {
    // const searchParams = new URLSearchParams({ email });
    const actionCodeSettings = {
        url: `${location.protocol}//${location.host}${path || location.pathname}`,
        handleCodeInApp: true,
    };
    yield (0, auth_1.sendPasswordResetEmail)(auth, email, actionCodeSettings);
    return true;
});
exports.useResetPasswordAdmin = createAsyncHook(resetPasswordAdmin);
const mailAuth = (_c) => __awaiter(void 0, [_c], void 0, function* ({ url }) {
    const urlParams = new URLSearchParams(new URL(url).search);
    const email = urlParams.get("email");
    if (!email) {
        throw new AppError("email is not defined in given URL", "ParameterError");
    }
    const response = yield (0, auth_1.signInWithEmailLink)(auth, email, url);
    console.log("signInWithEmailLink response", response);
    return response;
});
const useMailAuth = (params) => {
    const { data, error } = (0, swr_1.default)(params, mailAuth);
    return {
        data,
        error,
        loading: !!params && !data && !error,
    };
};
exports.useMailAuth = useMailAuth;
const signIn = (_d) => __awaiter(void 0, [_d], void 0, function* ({ email, password, }) {
    const response = yield (0, auth_1.signInWithEmailAndPassword)(auth, email, password);
    return response;
});
exports.useSignIn = createAsyncHook(signIn);
const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
    console.log("start singOut");
    yield (0, auth_1.signOut)(auth);
    console.log("finish signOut");
});
exports.signOut = signOut;
const isSignInWithEmailLink = (emailLink) => {
    return (0, auth_1.isSignInWithEmailLink)(auth, emailLink);
};
exports.isSignInWithEmailLink = isSignInWithEmailLink;
const changeUserPassword = (_e) => __awaiter(void 0, [_e], void 0, function* ({ currentPassword, newPassword, }) {
    const user = auth.currentUser;
    const email = user === null || user === void 0 ? void 0 : user.email;
    if (!email || !user) {
        throw new Error();
    }
    const credential = auth_1.EmailAuthProvider.credential(email, currentPassword);
    yield (0, auth_1.reauthenticateWithCredential)(user, credential);
    yield (0, auth_1.updatePassword)(user, newPassword);
});
exports.changeUserPassword = changeUserPassword;
exports.useAuthentication = (0, react_smart_hook_firebase_1.createAuthHook)(auth, (user) => user);
exports.useIdTokenResult = (0, react_smart_hook_firebase_1.createIdTokenHook)(auth, (user, claims) => {
    console.log({ user, claims });
    return {
        displayName: user === null || user === void 0 ? void 0 : user.displayName,
        photoURL: user === null || user === void 0 ? void 0 : user.photoURL,
        role: claims === null || claims === void 0 ? void 0 : claims.role,
        projectRoles: claims === null || claims === void 0 ? void 0 : claims.projectRoles,
        projectIds: Object.keys((claims === null || claims === void 0 ? void 0 : claims.projectRoles) || {}),
        uid: claims === null || claims === void 0 ? void 0 : claims.sub,
        email: claims === null || claims === void 0 ? void 0 : claims.email,
    };
});
const useAdminAuthentication = () => {
    const { data: user, error } = (0, exports.useIdTokenResult)();
    const loading = !user && !error;
    const isGuest = user && !user.uid;
    const isVerified = user === null || user === void 0 ? void 0 : user.uid;
    const isAdmin = isVerified && (user.role || user.projectRoles);
    const isNotAdmin = isVerified && !(user.role || user.projectRoles);
    return {
        isGuest,
        loading,
        error,
        isAdmin,
        isNotAdmin,
        user: (user === null || user === void 0 ? void 0 : user.uid) ? user : undefined,
        role: user === null || user === void 0 ? void 0 : user.role,
        projectRoles: user === null || user === void 0 ? void 0 : user.projectRoles,
        projectIds: user === null || user === void 0 ? void 0 : user.projectIds,
    };
};
exports.useAdminAuthentication = useAdminAuthentication;
